import type { OrganizationItem } from '@/features/organization/types/organization.types';

export interface UserFormLookups {
  companies: OrganizationItem[] | undefined;
  companiesLoading: boolean;
  departments: OrganizationItem[] | undefined;
  departmentsLoading: boolean;
  designations: OrganizationItem[] | undefined;
  designationsLoading: boolean;
}

export const USER_FORM_GRID_CLASS =
  'grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4';

export const SHARE_PARENT_GRID_CLASS = 'contents';
